module.exports = __webpack_public_path__ + "bin/4725aed16cf7852ff1d3fc120bcd079c.jpg";